module.exports = __webpack_public_path__ + "img/huzhou.092388d8.jpg";